<template>
    <div id="shortage" class="shortage-modal hide">
        <div class="modal-content">
            <button class="close-btn" @click="closeModal"><img src="@/assets/img/modal/close.svg" /></button>
            <div class="inner-content">
                <div class="padding">
                    <div class="gsection-title">
                        <h2 class="gtitle">Is the Vyvanse<sup>®</sup> shortage causing treatment challenges for your
                            patients?
                            If so, they may need a change.</h2>
                    </div>

                    <div class="copy">
                        <p>
                            Prescribe JORNAY PM (methylphenidate HCl extended-release capsules), a central nervous
                            system
                            (CNS)
                            stimulant indicated for the treatment of Attention Deficit Hyperactivity Disorder (ADHD) in
                            patients
                            6
                            years and older.
                        </p>

                    </div>

                    <div class="modal-img">
                        <img src="@/assets/img/modal/desktop-shortage-modal-img.png" class="desktop" />
                        <img src="@/assets/img/modal/mobile-shortage-modal-img.png" class="mobile" />
                    </div>
                    <div class="buttons">
                        <a class="button-accept" @click="acceptModal" href="javascript:void(0);">Learn More About JORNAY
                            PM</a>
                    </div>
                </div>
                <div class="modal-isi">
                    <div class="boxed">
                        <p>WARNING: ABUSE AND DEPENDENCE<br />
                            CNS stimulants, including JORNAY PM, other methylphenidate-containing products, and
                            amphetamines, have a high potential for abuse and dependence. Assess the risk of abuse prior
                            to
                            prescribing and monitor for signs of abuse and dependence while on therapy.</p>
                    </div>
                    <p>Please see additional Important Safety Information at <a href="https://www.jornaypm-pro.com/"
                            target="_blank">Jornaypm-pro.com</a> and <a
                            href="https://ironshorepharma.com/jornay-pm-label" target="_blank">Full Prescribing
                            Information</a>, including <span class="nowrap">Boxed
                            Warning.</span>
                    </p>
                </div>
            </div>
            <div class="modal-footer">
                <div class="flex">
                    <div><img src="@/assets/img/modal/ironshore-logo.png" /></div>
                    <div>
                        <p>This website is funded and developed by Ironshore. JORNAY PM, the JORNAY PM logo, Ironshore,
                            and
                            the Ironshore logo are trademarks of Ironshore or its related companies. The content of this
                            site is intended for US residents only.<br />
                            Vyvanse is a registered trademark of Takeda Pharmaceuticals U.S.A., Inc.</p>
                        <p>©2024 Ironshore IP001819 01/24</p>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>



<script>
export default {
    mounted() {

        let isAccepted = false;
        let element = document.getElementById("shortage");
        if (!isAccepted) {
            document.body.classList.add("overflow")
            element.classList.remove("hide");
        }
    },
    methods: {
        acceptModal() {
            let element = document.getElementById("shortage");
            sessionStorage.setItem('shortage_v', true)
            element.classList.add("hide");
            document.body.classList.remove("overflow")
            window.location = "/";
            this.$root.$emit('modal', 'accept')
        },

        closeModal() {
            sessionStorage.setItem('shortage_v', true)
            let element = document.getElementById("shortage");
            element.classList.add("hide");
            document.body.classList.remove("overflow")
            this.$root.$emit('modal', 'accept')
        }
    }

}
</script>